import clsx from 'clsx'
import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

import { mediaQueryUp } from 'components/utils/breakpoint'

import { StyledAccommodationRoomTileDetails } from './AccommodationRoomTileDetails'
import { AccommodationRoomTileImageContainer } from './AccommodationRoomTileImage'
import { mapRoomPackage } from './roomPackageUtils'

const AccommodationRoomTileGrid = styled.div`
  &.hasImage {
    display: grid;
    grid-template:
      "image" ${rem(223)}
      "details" auto / 1fr;

    ${mediaQueryUp.tablet} {
      grid-template:
        "image" ${rem(320)}
        "details" auto / 1fr;
    }

    ${mediaQueryUp.desktop} {
      grid-template: "image details" auto;
      &.image-size-medium {
        grid-template-columns: ${rem(400)} 1fr;
      }
      &.image-size-small {
        grid-template-columns: ${rem(300)} 1fr;
      }
    }

  }
  &:not(.hasImage) {
    display: grid;
    grid-template: "details" auto / 1fr;

    ${mediaQueryUp.tablet} {
      grid-template: "details" auto / 1fr;
    }

    ${mediaQueryUp.desktop} {
      grid-template: "details" auto / 1fr;
    }

    > ${AccommodationRoomTileImageContainer} {
      display: none;
    }
  }

  > ${AccommodationRoomTileImageContainer} {
    grid-area: image;
  }
  > ${StyledAccommodationRoomTileDetails} {
    grid-area: details;
  }
`
interface Props extends PropsWithChildren {
  roomPackage: App.Property.Room | App.HotelPackage | App.BedbankPackage
  imageSize?: 'small' | 'medium'
}

function AccommodationRoomTile(props: Props) {
  const { roomPackage, imageSize = 'medium', children } = props
  const hasImage = mapRoomPackage(
    roomPackage,
    ({ images }) => !!images.length,
    ({ roomType: { images } }) => !!images.length,
    ({ images }) => !!images.length,
  )

  return <AccommodationRoomTileGrid className={clsx({ hasImage }, `image-size-${imageSize}`)}>
    {children}
  </AccommodationRoomTileGrid>
}

export default AccommodationRoomTile
